// src/utils/logger.js
const logger = {
  log: (...args) => {
    if (import.meta.env.VITE_NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.log(...args)
    }
  },

  info: (...args) => {
    if (import.meta.env.VITE_NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.info('[INFO]:', ...args)
    }
  },

  error: (...args) => {
    if (import.meta.env.VITE_NODE_ENV !== 'production') {
      console.error(...args)
    }
    // You can send errors to an external service like Sentry here
  },

  warn: (...args) => {
    if (import.meta.env.VITE_NODE_ENV !== 'production') {
      console.warn(...args)
    }
  },

  debug: (...args) => {
    if (import.meta.env.VITE_NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.debug('[DEBUG]:', ...args)
    }
  },
}

export default logger
